// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_jn-2";
export var aiChatCartContainerExit = "_jn-4";
export var aiChatContainerLarge = "_jn-0";
export var aiChatContainerSmall = "_jn-1";
export var aiChatIcon = "_jn-6";
export var slideInFromRight = "_jn-3";
export var slideOutToRight = "_jn-5";